const t = {
  tableContainer: {
    border: "1px solid #EFEFEF",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    shadow: "none",
    overflowY: "auto",
    scrollbarWidth: "thin",
    padding: "0 16px",
    "&::-webkit-scrollbar": {
      width: "8px"
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent"
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#DADCE0",
      borderRadius: "4px"
    },
    backgroundColor: "#ffffff"
  },
  tableHead: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#ffffff",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      borderBottom: "1px solid #EFEFEF"
    }
  },
  tableHeaderCell: {
    padding: "12px 16px",
    position: "relative",
    color: "#878787",
    fontSize: "12px",
    fontWeight: "600",
    border: "none",
    "& .MuiButtonBase-root": {
      ":hover": {
        color: "#878787"
      }
    },
    "& .MuiButtonBase-root.Mui-active": {
      color: "#878787"
    }
  },
  tableHeaderRow: {
    backgroundColor: "#ffffff",
    ":hover": {
      backgroundColor: "#ffffff"
    }
  },
  filterIconContainer: {
    position: "absolute",
    right: "10px",
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.2s ease"
  },
  filterIcon: {
    height: "24px !important",
    width: "24px !important"
  },
  filterIconSvg: {
    fontSize: "16px !important"
  },
  tableBody: {
    position: "relative",
    backgroundColor: "#FFFFFF"
  },
  tableRow: {
    backgroundColor: "#FFFFFF"
  },
  tableCell: {
    padding: "12px 0",
    color: "#141414",
    fontSize: "12px",
    fontWeight: 500,
    borderBottom: "1px solid #EFEFEF",
    "&:first-of-type": {
      paddingLeft: "16px"
    },
    "&:last-of-type": {
      paddingRight: "16px"
    }
  },
  groupedRow: {
    display: "table-cell",
    paddingRight: "32px",
    borderBottom: "1px solid #EFEFEF",
    paddingTop: "12px",
    paddingBottom: "12px",
    fontSize: "12px",
    fontWeight: 500
  },
  groupedRowContent: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  emptyStateCell: {
    padding: "48px 16px",
    textAlign: "center",
    color: "#878787",
    fontSize: "14px",
    fontWeight: 500,
    borderBottom: "none",
    backgroundColor: "#ffffff"
  },
  loadingStateCell: {
    padding: "48px 16px",
    textAlign: "center",
    borderBottom: "none"
  },
  defaultLoadingSpinner: {
    margin: "0 auto"
  },
  expandButton: {
    transition: "transform 150ms ease-in-out",
    padding: 0
  },
  columnFilterContainer: {
    width: "250px",
    padding: "8px"
  },
  searchBarContainer: {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  },
  searchTextField: {
    marginBottom: 1,
    "& .MuiInputBase-root": {
      paddingLeft: "8px",
      "& .MuiInputBase-input.MuiOutlinedInput-input": {
        padding: "6px 6px 6px 0px",
        fontSize: "12px"
      }
    }
  },
  tableSearchTextField: {
    ml: "auto",
    minWidth: "346px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      height: "32px",
      fontSize: "12px"
    },
    "& .MuiInputAdornment-root": {
      marginRight: "8px",
      marTextFit: 1
    }
  },
  filterOptionRow: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5"
    },
    paddingLeft: "8px",
    paddingRight: "8px"
  },
  filterCheckbox: {
    padding: "4px",
    "& .MuiSvgIcon-root": {
      fontSize: "16px"
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  filterOptionText: {
    fontSize: "12px"
  },
  noResultsText: {
    padding: 1,
    textAlign: "center"
  },
  columnResizer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    userSelect: "none",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  resizerHandle: {
    width: "2px",
    height: "10px",
    backgroundColor: "#8080802e",
    borderRadius: "5px",
    cursor: "col-resize"
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #EFEFEF",
    backgroundColor: "#ffffff",
    position: "sticky",
    bottom: 0,
    left: -16,
    right: -16,
    minHeight: "min-content",
    zIndex: 2,
    padding: "0px 16px",
    marginRight: "-16px",
    marginLeft: "-16px",
    marginTop: "auto"
  },
  tablePagination: {
    backgroundColor: "#ffffff",
    minHeight: "min-content",
    "& .MuiTablePagination-toolbar": {
      minHeight: "48px",
      "& .MuiTablePagination-selectLabel": {
        margin: "0px",
        marginBottom: "4px"
      },
      "& .MuiTablePagination-select": {
        fontSize: "12px",
        "& .MuiSelect-select": {
          padding: "0px 24px 0px 8px"
        }
      }
    },
    marginLeft: "auto"
  },
  paginationText: {
    marginTop: "0px",
    color: "#141414",
    fontWeight: 500,
    fontSize: "12px"
  },
  paginationRowsPerPageText: {
    color: "#878787",
    fontWeight: 500,
    fontSize: "12px"
  },
  paginationActions: {
    display: "flex",
    gap: 0.5,
    alignItems: "center",
    marginLeft: "12px"
  },
  paginationButton: {
    "&:hover": {
      backgroundColor: "action.hover"
    }
  },
  rowsPerPageStack: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    spacing: 2,
    padding: "10px 0px",
    marginLeft: "auto"
  },
  rowsPerPageText: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#878787"
  },
  rowsPerPageSelect: {
    marginLeft: "9px",
    borderRadius: "8px",
    height: "28px",
    fontSize: "12px",
    color: "#878787",
    backgroundColor: "#F7F7F7",
    "& fieldset": {
      borderColor: "#EFEFEF !important",
      borderWidth: "1px !important"
    }
  },
  paginationStyle: {
    color: "#226A58",
    "&.MuiPagination-root.MuiPagination-outlined": {
      marginLeft: "16px",
      "& ul": {
        gap: "4px",
        "& li": {
          "& button": {
            margin: 0,
            backgroundColor: "#FFFFFF",
            color: "#141414",
            borderRadius: "8px",
            border: "1px solid #CDD2DBB2",
            fontSize: "13px",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#F7F7F7"
            },
            "&.Mui-selected": {
              backgroundColor: "#226A58",
              color: "#FFFFFF",
              borderRadius: "8px",
              border: "none"
            }
          }
        }
      }
    }
  },
  virtualizedTableBody: {
    height: "100%",
    overflow: "hidden",
    tableLayout: "fixed",
    width: "100%"
  },
  virtualizedTableCell: {
    padding: 0,
    width: "100%"
  },
  virtualizedListContainer: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  virtualizedList: {
    overflowX: "hidden",
    width: "100%"
  },
  checkbox: {
    padding: "0px",
    width: "16px",
    height: "20px",
    "&.Mui-checked": {
      color: "#226A58"
    },
    "&.MuiCheckbox-indeterminate": {
      color: "#226A58"
    }
  },
  dragGhost: {
    position: "fixed",
    top: "-1000px",
    left: "-1000px",
    padding: "0",
    pointerEvents: "none"
  },
  dragGhostCard: {
    background: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0px 4px 7px 0px #0000001A",
    padding: "8px",
    position: "absolute",
    height: "100%"
  },
  dragGhostText: {
    color: "#222325",
    fontSize: "12px",
    fontWeight: "400",
    whiteSpace: "nowrap",
    visibility: "hidden",
    position: "absolute",
    padding: "8px"
  },
  dragGhostStackContainer: {
    position: "relative",
    height: "31px"
  },
  dragGhostTopCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "max-content"
  },
  dragGhostRow: {
    color: "#222325",
    fontSize: "12px",
    fontWeight: "400",
    whiteSpace: "wrap",
    textAlign: "center"
  },
  dragGhostIconContainer: {
    position: "absolute",
    top: "1px",
    left: "-7px",
    transform: "translateY(-50%)",
    zIndex: "15",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: "1"
  },
  headerSelectionCell: {
    width: "54px",
    maxWidth: "54px",
    minWidth: "54px"
  },
  headerDragCell: {
    paddingLeft: "16px",
    width: "40px",
    maxWidth: "40px",
    minWidth: "40px"
  },
  bodySelectionCell: {
    paddingLeft: "32px",
    borderBottom: "1px solid #EFEFEF",
    width: "54px",
    maxWidth: "54px",
    minWidth: "54px"
  },
  bodyDragCell: {
    paddingLeft: "16px",
    width: "40px",
    maxWidth: "40px",
    minWidth: "40px"
  },
  bodyDragCellNoSelection: {
    paddingLeft: "32px"
  },
  dragIndicator: {
    color: "grey",
    cursor: "grab",
    height: "16px",
    width: "16px"
  },
  dragIndicatorContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  bodyCell: {
    paddingLeft: "16px",
    paddingRight: "16px",
    borderBottom: "1px solid #EFEFEF",
    boxSizing: "border-box"
  },
  bodyCellFirst: {
    paddingLeft: "32px"
  },
  bodyCellLast: {
    paddingRight: "32px"
  },
  bodyCellLastRow: {
    borderBottom: "none"
  }
};
export {
  t as styles
};
